export default __webpack_public_path__ + "static/media/trackinfo_tunnel.fd1ddf5e.avif";